import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.sidebar/view.scss */
:host {
  display: contents;
}

.nf-sidebar {
  display: flex;
  width: 100%;
  height: 100%;
  min-width: 0;
  flex-direction: column;
  overflow: hidden;
  border-right: 1px solid #16253d;
  background: #08162b;
  color: #93a1b6;
}

.nf-sidebar-brand {
  display: flex;
  height: 64px;
  min-height: 64px;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.12);
  padding: 0 16px 0 22px;
}

.nf-sidebar-logo {
  display: flex;
  min-width: 0;
  flex: 1 1 auto;
  align-items: center;
  color: #ffffff;
}

.nf-sidebar-logo-full {
  display: flex;
  width: auto;
  max-width: 100%;
  height: 40px;
  align-items: center;
  gap: 8px;
}

.nf-sidebar-logo-wordmark {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 7px;
}

.nf-sidebar-logo-wordmark img {
  display: block;
  width: 92px;
  height: auto;
  filter: brightness(0) invert(1);
}

.nf-sidebar-logo-wordmark strong {
  display: block;
  overflow: hidden;
  color: #ffffff;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.01em;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nf-sidebar-logo-compact {
  display: none;
  width: 38px;
  height: 38px;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #1268ff;
  color: #ffffff;
  font-size: 13px;
  font-weight: 850;
  letter-spacing: -0.02em;
}

.nf-sidebar-collapse,
.nf-sidebar-mobile-close {
  display: inline-flex;
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  color: #66758b;
  font-size: 13px;
  transition: border-color 0.16s ease, background-color 0.16s ease, color 0.16s ease;
}

.nf-sidebar-mobile-close {
  display: none;
}

.nf-sidebar-collapse:hover,
.nf-sidebar-mobile-close:hover {
  border-color: rgba(148, 163, 184, 0.18);
  background: rgba(255, 255, 255, 0.07);
  color: #ffffff;
}

.nf-sidebar-logo:focus-visible,
.nf-sidebar-collapse:focus-visible,
.nf-sidebar-mobile-close:focus-visible,
.nf-nav-group-trigger:focus-visible,
.nf-nav-group-toggle:focus-visible,
.nf-nav-item:focus-visible,
.nf-sidebar-button:focus-visible {
  outline: 3px solid rgba(18, 104, 255, 0.38);
  outline-offset: 2px;
}

.nf-sidebar-nav {
  min-height: 0;
  flex: 1 1 auto;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 14px 16px 18px;
  scrollbar-color: #243753 transparent;
  scrollbar-width: thin;
}

.nf-sidebar-nav::-webkit-scrollbar {
  width: 6px;
}

.nf-sidebar-nav::-webkit-scrollbar-track {
  background: transparent;
}

.nf-sidebar-nav::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: #243753;
}

.nf-nav-section + .nf-nav-section {
  margin-top: 20px;
}

.nf-nav-section-title {
  margin: 0 0 8px;
  padding: 0 12px;
  color: #526177;
  font-size: 12px;
  font-weight: 750;
  letter-spacing: 0.04em;
  line-height: 18px;
}

.nf-nav-group {
  position: relative;
}

.nf-nav-group + .nf-nav-group {
  margin-top: 2px;
}

.nf-nav-group-row {
  position: relative;
  display: flex;
  min-width: 0;
  align-items: center;
}

.nf-nav-group-trigger {
  display: flex;
  width: 100%;
  min-width: 0;
  min-height: 50px;
  align-items: center;
  gap: 12px;
  border: 1px solid transparent;
  border-radius: 8px;
  padding: 0 34px 0 12px;
  color: #8f9db2;
  text-decoration: none;
  transition: border-color 0.16s ease, background-color 0.16s ease, color 0.16s ease;
}

.nf-nav-group-trigger:hover {
  border-color: rgba(148, 163, 184, 0.08);
  background: #10213a;
  color: #d7e1ef;
}

.nf-nav-icon {
  display: inline-flex;
  width: 24px;
  height: 24px;
  flex: 0 0 24px;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  color: #7e8da4;
  transition: background-color 0.16s ease, color 0.16s ease;
}

.nf-nav-icon i {
  font-size: 16px;
  line-height: 1;
}

.nf-sidebar-label {
  display: flex;
  min-width: 0;
  flex: 1 1 auto;
  flex-direction: column;
}

.nf-sidebar-title {
  overflow: hidden;
  color: inherit;
  font-size: 13px;
  font-weight: 650;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nf-nav-end {
  position: absolute;
  top: 50%;
  right: 13px;
  display: inline-flex;
  width: 18px;
  height: 18px;
  align-items: center;
  justify-content: center;
  color: #607087;
  font-size: 12px;
  transform: translateY(-50%);
}

.nf-nav-group-toggle {
  position: absolute;
  top: 50%;
  right: 5px;
  z-index: 2;
  display: inline-flex;
  width: 34px;
  height: 38px;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #607087;
  transform: translateY(-50%);
  transition: background-color 0.16s ease, color 0.16s ease;
}

.nf-nav-group-toggle:hover {
  background: rgba(255, 255, 255, 0.06);
  color: #ffffff;
}

.nf-nav-caret {
  display: inline-flex;
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  transition: transform 0.16s ease;
}

.nf-nav-caret-open {
  transform: rotate(90deg);
}

.nf-nav-group-active > .nf-nav-group-row .nf-nav-group-trigger {
  border-color: #1268ff;
  background: #1268ff;
  color: #ffffff;
  box-shadow: 0 8px 20px rgba(18, 104, 255, 0.22);
}

.nf-nav-group-active > .nf-nav-group-row .nf-nav-icon,
.nf-nav-group-active > .nf-nav-group-row .nf-nav-end,
.nf-nav-group-active > .nf-nav-group-row .nf-nav-group-toggle {
  color: #ffffff;
}

.nf-nav-group-active > .nf-nav-group-row .nf-nav-group-toggle:hover {
  background: rgba(255, 255, 255, 0.14);
}

.nf-subnav {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin: 5px 0 7px 24px;
  border-left: 1px solid #253753;
  padding: 3px 0 3px 12px;
}

.nf-nav-item {
  display: flex;
  min-width: 0;
  min-height: 40px;
  align-items: center;
  gap: 9px;
  border-radius: 7px;
  padding: 0 10px;
  color: #7f8da2;
  text-decoration: none;
  transition: background-color 0.16s ease, color 0.16s ease;
}

.nf-nav-item:hover {
  background: #10213a;
  color: #d7e1ef;
}

.nf-subnav-dot {
  width: 5px;
  height: 5px;
  flex: 0 0 5px;
  border-radius: 999px;
  background: #4c607c;
}

.nf-nav-item-active {
  background: rgba(18, 104, 255, 0.16);
  color: #dceaff;
}

.nf-nav-item-active .nf-sidebar-title {
  color: #dceaff;
  font-weight: 750;
}

.nf-nav-item-active .nf-subnav-dot {
  background: #4c91ff;
}

.nf-sidebar-footer {
  display: flex;
  flex-direction: column;
  gap: 2px;
  border-top: 1px solid rgba(148, 163, 184, 0.12);
  padding: 10px 16px 12px;
}

.nf-sidebar-button {
  display: flex;
  width: 100%;
  min-height: 42px;
  align-items: center;
  gap: 11px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  padding: 0 12px;
  color: #7f8da2;
  font-size: 12px;
  font-weight: 650;
  text-align: left;
  text-decoration: none;
  transition: border-color 0.16s ease, background-color 0.16s ease, color 0.16s ease;
}

.nf-sidebar-button:hover,
.nf-sidebar-button[aria-current=page] {
  border-color: rgba(148, 163, 184, 0.09);
  background: #10213a;
  color: #d7e1ef;
}

.nf-sidebar-footer-icon {
  display: inline-flex;
  width: 22px;
  height: 22px;
  flex: 0 0 22px;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.nf-sidebar-footer-copy {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nf-sidebar-collapsed .nf-sidebar-brand {
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  height: 86px;
  min-height: 86px;
  padding: 8px;
}

.nf-sidebar-collapsed .nf-sidebar-logo {
  flex: 0 0 auto;
}

.nf-sidebar-collapsed .nf-sidebar-logo-full,
.nf-sidebar-collapsed .nf-sidebar-label,
.nf-sidebar-collapsed .nf-sidebar-footer-copy,
.nf-sidebar-collapsed .nf-nav-section-title,
.nf-sidebar-collapsed .nf-nav-end,
.nf-sidebar-collapsed .nf-nav-caret,
.nf-sidebar-collapsed .nf-subnav {
  display: none;
}

.nf-sidebar-collapsed .nf-sidebar-logo-compact {
  display: inline-flex;
}

.nf-sidebar-collapsed .nf-sidebar-collapse {
  width: 30px;
  height: 26px;
}

.nf-sidebar-collapsed .nf-sidebar-nav {
  padding: 12px 9px;
}

.nf-sidebar-collapsed .nf-nav-section + .nf-nav-section {
  margin-top: 12px;
  border-top: 1px solid rgba(148, 163, 184, 0.12);
  padding-top: 12px;
}

.nf-sidebar-collapsed .nf-nav-group-trigger {
  min-height: 48px;
  justify-content: center;
  padding: 0;
}

.nf-sidebar-collapsed .nf-nav-group-toggle {
  display: none;
}

.nf-sidebar-collapsed .nf-sidebar-footer {
  padding: 9px;
}

.nf-sidebar-collapsed .nf-sidebar-button {
  justify-content: center;
  padding: 0;
}

@media (max-width: 1023px) {
  .nf-sidebar {
    border-right: 0;
  }
  .nf-sidebar-brand,
  .nf-sidebar-collapsed .nf-sidebar-brand {
    height: 64px;
    min-height: 64px;
    flex-direction: row;
    justify-content: space-between;
    gap: 10px;
    padding: 0 14px 0 20px;
  }
  .nf-sidebar-collapsed .nf-sidebar-logo {
    flex: 1 1 auto;
  }
  .nf-sidebar-collapsed .nf-sidebar-logo-full,
  .nf-sidebar-collapsed .nf-sidebar-label,
  .nf-sidebar-collapsed .nf-sidebar-footer-copy,
  .nf-sidebar-collapsed .nf-nav-section-title,
  .nf-sidebar-collapsed .nf-nav-end,
  .nf-sidebar-collapsed .nf-nav-caret {
    display: flex;
  }
  .nf-sidebar-collapsed .nf-sidebar-logo-compact,
  .nf-sidebar-collapse {
    display: none;
  }
  .nf-sidebar-mobile-close {
    display: inline-flex;
  }
  .nf-sidebar-nav,
  .nf-sidebar-collapsed .nf-sidebar-nav {
    padding: 14px 16px 18px;
  }
  .nf-sidebar-collapsed .nf-nav-section + .nf-nav-section {
    margin-top: 20px;
    border-top: 0;
    padding-top: 0;
  }
  .nf-sidebar-collapsed .nf-nav-group-trigger {
    min-height: 50px;
    justify-content: flex-start;
    padding: 0 34px 0 12px;
  }
  .nf-sidebar-collapsed .nf-nav-group-toggle {
    display: inline-flex;
  }
  .nf-sidebar-collapsed .nf-subnav {
    display: flex;
  }
  .nf-sidebar-footer,
  .nf-sidebar-collapsed .nf-sidebar-footer {
    padding: 10px 16px 14px;
  }
  .nf-sidebar-collapsed .nf-sidebar-button {
    justify-content: flex-start;
    padding: 0 12px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .nf-sidebar *,
  .nf-sidebar *::before,
  .nf-sidebar *::after {
    scroll-behavior: auto !important;
    transition-duration: 0.01ms !important;
  }
}`],
})
export class ComponentNavSidebarComponent implements OnInit {
    public theme: string = 'light';
    public collapsed: boolean = false;
    private themeStorageKey: string = 'nanofab.theme';
    private sidebarStorageKey: string = 'nanofab.sidebar.collapsed';

    public expandedGroups: any = {};
    public navSections: any[] = [];
    public navGroups: any[] = [];
    private activePath: string = '';

    private analysisGroup = {
        route: '/agent/analysis',
        label: '분석',
        menuLabel: '데이터 분석 환경',
        sub: '시각화·예측·워크플로',
        icon: 'fa-chart-simple',
        children: [
            { route: '/agent/visualization', section: 'visualization', label: '시각화·보고서', sub: '표현·내보내기', icon: 'fa-chart-pie' },
            { route: '/agent/analysis', section: 'analysis', label: '예측·추론', sub: '모델·RCA 검토', icon: 'fa-microchip' },
            { route: '/agent/workflows', section: 'workflows', label: '워크플로', sub: '반복 분석 자동화', icon: 'fa-diagram-project' },
        ],
    };

    private menuItems = [
        {
            route: '/dashboard',
            home: true,
            label: '대시보드',
            icon: 'fa-table-cells-large',
            children: [],
        },
        {
            route: '/agent/history',
            section: 'history',
            label: '데이터 허브',
            menuLabel: 'Agent 데이터 허브',
            sub: '원본 조회·필터',
            icon: 'fa-database',
            relatedSections: ['lot-history', 'trace'],
            children: [],
        },
        {
            route: '/agent/chat',
            section: 'chat',
            label: 'AI Agent',
            menuLabel: '지능형 분석 서비스',
            sub: '질문·답변·검증',
            icon: 'fa-lightbulb',
            children: [],
        },
    ];

    private cloneItem(item: any) {
        return {
            ...item,
            children: item.children ? item.children.map((child: any) => ({ ...child, query: child.query ? { ...child.query } : undefined })) : [],
        };
    }

    private buildNavSections() {
        const isAdmin = this.service.auth.session?.role === 'admin';
        const pageItems = [
            this.analysisGroup,
            isAdmin
                ? { route: '/agent/quality', section: 'quality', label: '데이터·품질 운영', icon: 'fa-graduation-cap', children: [] }
                : { route: '/agent/training', section: 'training', label: 'AI 반도체 공정 교육', icon: 'fa-graduation-cap', children: [] },
        ];
        if (isAdmin) {
            pageItems.push({ route: '/agent/stats', section: 'stats', label: '통계', icon: 'fa-chart-pie', children: [] });
        }
        const componentItems = [
            { route: '/posts', label: '사용자 지원', icon: 'fa-user', children: [] },
            isAdmin
                ? {
                    route: '/agent/admin', section: 'admin', label: '설정', icon: 'fa-gear', children: [
                        { route: '/agent/admin', section: 'admin', query: { workspace: 'llm' }, label: 'LLM 모델', icon: 'fa-message' },
                        { route: '/agent/admin', section: 'admin', query: { workspace: 'document-ai' }, label: '문서 AI·데이터 모델', icon: 'fa-file-waveform' },
                        { route: '/agent/admin', section: 'admin', query: { workspace: 'operations' }, label: '운영·보안', icon: 'fa-shield-halved' },
                    ]
                }
                : { route: '/mypage', label: '설정', icon: 'fa-gear', children: [] },
        ];

        return [
            { id: 'menu', label: 'MENU', items: this.menuItems.map((item: any) => this.cloneItem(item)) },
            { id: 'pages', label: 'PAGES', items: pageItems.map((item: any) => this.cloneItem(item)) },
            { id: 'components', label: 'COMPONENTS', items: componentItems.map((item: any) => this.cloneItem(item)) },
        ];
    }

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.navSections = this.buildNavSections();
        this.navGroups = this.navSections.reduce((items: any[], section: any) => items.concat(section.items || []), []);
        this.syncExpandedGroup();
        this.collapsed = this.detectCollapsed();
        this.applyTheme(this.detectTheme());
    }

    @HostListener('document:click')
    public clickout() {
        this.service.status.toggle('navbar', false);
    }

    public currentAgentSection(): string {
        const match = location.pathname.match(/^\/agent\/([\w-]+)/);
        return match ? match[1] : 'chat';
    }

    public navGroupClass(group: any) {
        return this.isGroupActive(group) ? 'nf-nav-group nf-nav-group-active' : 'nf-nav-group';
    }

    public homeClass() {
        return this.isHomeActive() ? 'nf-nav-home nf-nav-home-active' : 'nf-nav-home';
    }

    public isHomeActive() {
        return location.pathname === '/dashboard' || location.pathname === '/';
    }

    public navChildClass(item: any) {
        return this.isNavTargetActive(item) ? 'nf-nav-item nf-nav-item-active' : 'nf-nav-item';
    }

    public async toggleGroup(group: any, event?: Event) {
        if (this.collapsed && !this.isMobileViewport()) return;
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        const key = this.groupKey(group);
        this.expandedGroups[key] = !this.isGroupExpanded(group);
        await this.service.render();
    }

    public openGroup(group: any) {
        this.expandedGroups[this.groupKey(group)] = true;
        this.activePath = group.route;
        this.closeMobileSidebar();
    }

    public openNavItem(group: any) {
        this.expandedGroups[this.groupKey(group)] = true;
        this.closeMobileSidebar();
    }

    public groupToggleLabel(group: any) {
        return `${group.label} 하위 메뉴 ${this.isGroupExpanded(group) ? '접기' : '펼치기'}`;
    }

    public isGroupExpanded(group: any) {
        if (this.collapsed && !this.isMobileViewport()) return false;
        this.syncExpandedGroup();
        const key = this.groupKey(group);
        if (typeof this.expandedGroups[key] === 'boolean') return this.expandedGroups[key];
        return false;
    }

    public isGroupActive(group: any) {
        if (group.home) return this.isHomeActive();
        if (group.section && this.isNavTargetActive(group)) return true;
        if (group.children?.some((item: any) => this.isNavTargetActive(item))) return true;
        return location.pathname.indexOf('/agent') === 0
            && (group.relatedSections || []).includes(this.currentAgentSection());
    }

    public isNavTargetActive(item: any) {
        const path = location.pathname;
        const params = new URLSearchParams(location.search);
        if (item.home) return this.isHomeActive();
        if (item.query) {
            return this.isQueryTargetActive(item, path, params);
        }
        if (item.section) {
            return path.indexOf('/agent') === 0 && this.currentAgentSection() === item.section;
        }
        return path.indexOf(item.route) === 0;
    }

    private isQueryTargetActive(item: any, path: string, params: URLSearchParams) {
        if (path.indexOf(item.route) !== 0) return false;
        return Object.keys(item.query || {}).every((key: string) => {
            const defaults: any = { tab: 'account', workspace: 'llm' };
            const current = params.get(key) || defaults[key] || null;
            return current === item.query[key];
        });
    }

    private groupKey(group: any) {
        return group.route || group.label;
    }

    private syncExpandedGroup() {
        const path = location.pathname;
        if (this.activePath === path) return;
        this.activePath = path;
        const activeGroup = this.navGroups.find((group: any) => this.isGroupActive(group));
        if (activeGroup) this.expandedGroups[this.groupKey(activeGroup)] = true;
    }

    public async toggleCollapsed(event?: Event) {
        if (event) event.stopPropagation();
        if (this.isMobileViewport()) {
            this.closeMobileSidebar();
            return;
        }
        this.collapsed = !this.collapsed;
        try {
            localStorage.setItem(this.sidebarStorageKey, this.collapsed ? '1' : '0');
        } catch (error) { }
        window.dispatchEvent(new CustomEvent('nanofab-sidebar-collapse', { detail: this.collapsed }));
        await this.service.render();
    }

    public collapseLabel() {
        return this.collapsed ? '사이드바 펼치기' : '사이드바 접기';
    }

    public isPathActive(path: string) {
        return location.pathname.indexOf(path) === 0;
    }

    public closeMobileSidebar(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!this.isMobileViewport()) return;
        window.dispatchEvent(new CustomEvent('nanofab-mobile-sidebar-close'));
    }

    private isMobileViewport() {
        return typeof window !== 'undefined' && window.innerWidth < 1024;
    }

    public async toggleTheme(event?: Event) {
        if (event) event.stopPropagation();
        this.applyTheme(this.theme === 'dark' ? 'light' : 'dark');
        await this.service.render();
    }

    public themeLabel() {
        return this.theme === 'dark' ? '화이트 모드로 전환' : '다크 모드로 전환';
    }

    private detectTheme() {
        try {
            const saved = localStorage.getItem(this.themeStorageKey);
            if (saved === 'dark' || saved === 'light') return saved;
        } catch (error) { }
        return document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
    }

    private applyTheme(theme: string) {
        this.theme = theme === 'dark' ? 'dark' : 'light';
        document.documentElement.setAttribute('data-theme', this.theme);
        document.documentElement.style.colorScheme = this.theme;
        const meta = document.querySelector('meta[name="theme-color"]');
        if (meta) meta.setAttribute('content', this.theme === 'dark' ? '#071321' : '#2e6fae');
        try {
            localStorage.setItem(this.themeStorageKey, this.theme);
        } catch (error) { }
    }

    private detectCollapsed() {
        try {
            return localStorage.getItem(this.sidebarStorageKey) === '1';
        } catch (error) { }
        return false;
    }

    public async logout() {
        localStorage.removeItem('fab.auth.session');
        await this.service.request.post('/wiz/api/page.access/login', { email: '__logout__', password: '_' });
        location.href = '/access';
    }
}

export default ComponentNavSidebarComponent;